import React from 'react';
import { Box } from '@tanium/react-box';
import { SimpleTooltip } from '@tanium/react-tooltip';
import { ThemeFontWeights } from '@tanium/theme-data';
import { Trans } from './localization';
import { SelectedCountsText } from './themeDefinitions';

export interface ResultsCountsMetricProps {
  /**
   * The count of selected items.
   */
  count: number;
  /**
   * Content to display in a tooltip when hovering over the count of items.
   */
  tooltipContent?: React.ReactNode;
}

export const ResultsSelectedCountsMetric = ({
  count,
  tooltipContent,
}: ResultsCountsMetricProps) => (
  <div>
    <SimpleTooltip content={tooltipContent}>
      {({ ref }) => (
        <span ref={ref}>
          <Trans count={count}>
            <Box as="span" color={SelectedCountsText} fontWeight={ThemeFontWeights.Bold}>
              {'{{ count, INTEGER }}'}
            </Box>{' '}
            <Box as="span" color={SelectedCountsText} fontWeight={ThemeFontWeights.Normal}>
              Selected
            </Box>
          </Trans>
        </span>
      )}
    </SimpleTooltip>
  </div>
);
